import { render, staticRenderFns } from "./BrandProductArea.vue?vue&type=template&id=eab5e75a&scoped=true"
import script from "./BrandProductArea.vue?vue&type=script&lang=js"
export * from "./BrandProductArea.vue?vue&type=script&lang=js"
import style0 from "./BrandProductArea.vue?vue&type=style&index=0&id=eab5e75a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eab5e75a",
  null
  
)

export default component.exports